import { useState } from 'react';
import FacebookIcon from 'svg/icon-facebook.svg';
import XIcon from 'svg/icon-x.svg';
import LinkedInIcon from 'svg/icon-linkedin.svg';
import WhatsAppIcon from 'svg/whatsapp.svg';
import EmailIcon from 'svg/icon-mail.svg';
import LinkIcon from 'svg/link.svg';

export default function ShareButtons({ hideOnDesktop = false, url }) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(decodeURIComponent(url));
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div
      className={`c-share-buttons${
        hideOnDesktop ? ' c-share-buttons--hide-on-desktop' : ''
      }`}
    >
      <h3 className="c-share-buttons__heading">Deel vacature:</h3>
      <ul className="c-share-buttons__list">
        <li>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="c-share-buttons__button"
            aria-label="Deel op Facebook"
          >
            <FacebookIcon />
          </a>
        </li>
        <li>
          <a
            href={`https://x.com/intent/tweet?url=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="c-share-buttons__button"
            aria-label="Deel op X"
          >
            <XIcon />
          </a>
        </li>
        <li>
          <a
            href={`https://www.linkedin.com/feed/?shareActive=true&text=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="c-share-buttons__button"
            aria-label="Deel op LinkedIn"
          >
            <LinkedInIcon />
          </a>
        </li>
        <li>
          <a
            href={`https://wa.me/?text=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="c-share-buttons__button"
            aria-label="Deel via WhatsApp"
          >
            <WhatsAppIcon />
          </a>
        </li>
        <li>
          <a
            href={`mailto:?body=${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="c-share-buttons__button"
            aria-label="Deel via e-mail"
          >
            <EmailIcon />
          </a>
        </li>
        <li>
          <button
            type="button"
            onClick={handleCopyLink}
            className={`c-share-buttons__button c-share-buttons__copy-button ${
              isCopied ? 'c-share-buttons__copy-button--copied' : ''
            }`}
            aria-label="Kopieer link naar klembord"
          >
            <LinkIcon />
          </button>
        </li>
      </ul>
    </div>
  );
}
